// src/pages/Register.js
import React, { useState } from 'react';
import styles from '../assets/css/Register.module.css';
import { motion } from 'framer-motion';
import ParticleBackground from '../components/ParticleBackground';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { registrarUsuario } from '../services/user/User';
import { useNavigate } from 'react-router-dom';

function Register() {
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    tipo: 'farmacia', // fijo
  });

  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { username, email, password, first_name, last_name } = form;
    if (!username || !email || !password || !first_name || !last_name) {
      toast.error('Todos los campos son obligatorios');
      return;
    }

    try {
      setSending(true);
      await registrarUsuario(form);
      toast.success('Usuario registrado con éxito');
      setForm({
        username: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        tipo: 'farmacia',
      });
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={styles.registerContainer}>
      <ParticleBackground />
      <ToastContainer position="top-center" autoClose={3000} />

      <motion.form
        className={styles.registerForm}
        onSubmit={handleSubmit}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2>Solicitar acceso</h2>

        <motion.input
          name="username"
          type="text"
          placeholder="Nombre de usuario"
          value={form.username}
          onChange={handleChange}
          required
          whileFocus={{ scale: 1.02 }}
        />

        <motion.input
          name="first_name"
          type="text"
          placeholder="Nombre"
          value={form.first_name}
          onChange={handleChange}
          required
          whileFocus={{ scale: 1.02 }}
        />

        <motion.input
          name="last_name"
          type="text"
          placeholder="Apellido"
          value={form.last_name}
          onChange={handleChange}
          required
          whileFocus={{ scale: 1.02 }}
        />

        <motion.input
          name="email"
          type="email"
          placeholder="Correo electrónico"
          value={form.email}
          onChange={handleChange}
          required
          whileFocus={{ scale: 1.02 }}
        />

        <motion.input
          name="password"
          type="password"
          placeholder="Contraseña"
          value={form.password}
          onChange={handleChange}
          required
          whileFocus={{ scale: 1.02 }}
        />

        <motion.button
          type="submit"
          disabled={sending}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {sending ? 'Registrando...' : 'Registrar'}
        </motion.button>
      </motion.form>
    </div>
  );
}

export default Register;
